export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./cashback-bonus.vue?vue&type=template&id=5246c8b6"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/cashback-bonus.vue?vue&type=template&id=5246c8b6
// module id = YStF
// module chunks = 0